import { BrowserRouter, Route, Routes } from "react-router-dom";

import NavBar from "./Component/NavBar";
import Home from "./Home";
import Resume from "./Resume";
import Footer from "./Component/Footer";
import { useColorTheme } from "./hooks/useColorTheme";

function App() {
  // Initialize random color theme on mount
  useColorTheme();

  return (
    <>
      <div>
        <NavBar />

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resume" element={<Resume />} />
          </Routes>
        </BrowserRouter>

        <Footer />
      </div>
    </>
  );
}

export default App;
